// ChatIframe.tsx
import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";

interface ChatIframeProps {
  platform: string;
  liveChatUrl: string | null;
  isLive: boolean;
}

const ChatIframe: React.FC<ChatIframeProps> = ({ platform, liveChatUrl, isLive }) => {
  if (!isLive || !liveChatUrl) {
    return (
      <View style={styles.chatPlaceholder}>
        <Text style={[AppFontStyle.BOLD_ANYBODY_16, { color: AppColors.white }]}>
          {platform}
        </Text>
        <Text style={[AppFontStyle.BOLD_ANYBODY_24, { color: "#FACC15" }]}>
          Stream is Offline
        </Text>
      </View>
    );
  }

  return (
    <iframe
      src={liveChatUrl}
      style={{ width: "100%", height: 365 }}
      frameBorder="0"
      scrolling="no"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowFullScreen
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"
      title={`${platform} Chat`}
      onLoad={() => console.log(`Iframe loaded for ${platform} with URL:`, liveChatUrl)}
      onError={() => console.log(`Iframe error for ${platform} with URL:`, liveChatUrl)}
    />
  );
};

const styles = StyleSheet.create({
  chatPlaceholder: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default ChatIframe;